<template>
  <footer
    class="jdih-footer"
    :style="{
      '--accent': accentColor,
      '--accent-deep': accentDeep,
      '--accent-soft': accentSoft
    }"
  >
    <div class="jdih-footer__inner">
      <div class="jdih-footer__main">
        <div class="jdih-footer__brand">
          <div class="jdih-footer__logos">
            <img
              :src="require('@/assets/logo/jdihn.png')"
              alt="JDIH"
              width="36"
              height="36"
              class="jdih-footer__logo"
            >
            <img
              :src="require('@/assets/logo/favicon-logo.png')"
              alt="Setwan Kabupaten Klaten"
              width="88"
              height="36"
              class="jdih-footer__logo jdih-footer__logo--setwan"
            >
          </div>
          <div>
            <div class="jdih-footer__title">JDIH Sekretariat DPRD</div>
            <div class="jdih-footer__sub">Kabupaten Klaten</div>
            <p class="jdih-footer__desc">
              Jaringan Dokumentasi dan Informasi Hukum Sekretariat DPRD Kabupaten Klaten.
            </p>
          </div>
        </div>

        <div class="jdih-footer__col">
          <div class="jdih-footer__label">Kontak</div>
          <a
            class="jdih-footer__line"
            href="https://maps.google.com/?q=Jalan+Pemuda+Nomor+294+Klaten"
            target="_blank"
            rel="noopener noreferrer"
          >
            <v-icon size="15" color="rgba(255,255,255,0.7)">mdi-map-marker-outline</v-icon>
            <span>Jalan Pemuda No. 294, Klaten 57424</span>
          </a>
          <a class="jdih-footer__line" href="tel:0272321046">
            <v-icon size="15" color="rgba(255,255,255,0.7)">mdi-phone-outline</v-icon>
            <span>0272-321046</span>
          </a>
          <a class="jdih-footer__line" href="mailto:dprdklaten@gmail.com">
            <v-icon size="15" color="rgba(255,255,255,0.7)">mdi-email-outline</v-icon>
            <span>dprdklaten@gmail.com</span>
          </a>
        </div>

        <div class="jdih-footer__col jdih-footer__col--stats">
          <div class="jdih-footer__label">Pengunjung</div>
          <div class="jdih-footer__stats">
            <div
              v-for="(item, index) in people"
              :key="index"
              class="jdih-footer__stat"
              :class="{ 'is-total': index === people.length - 1 }"
            >
              <div class="jdih-footer__stat-num">{{ formatNumber(item.number) }}</div>
              <div class="jdih-footer__stat-label">{{ item.short }}</div>
            </div>
          </div>
        </div>

        <div class="jdih-footer__col">
          <div class="jdih-footer__label">Ikuti kami</div>
          <div class="jdih-footer__social">
            <a
              v-for="(item, index) in sosmed"
              :key="index"
              :href="item.link"
              :aria-label="item.network"
              target="_blank"
              rel="noopener noreferrer"
              class="jdih-footer__social-btn"
            >
              <img :src="item.icon" :alt="item.network" width="16" height="16">
            </a>
          </div>
          <nuxt-link to="/hubungi-kami" class="jdih-footer__cta">
            Hubungi kami
            <v-icon size="14" color="#fff">mdi-arrow-right</v-icon>
          </nuxt-link>
        </div>
      </div>

      <div class="jdih-footer__bar">
        <span>© {{ year }} Setwan Kabupaten Klaten</span>
        <span>Dibuat oleh Diskominfo Kabupaten Klaten</span>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    data () {
      return {
        sosmed: [
          {
            network: 'Instagram',
            link: 'https://www.instagram.com/jdihklaten/',
            icon: require('@/assets/sosmed/instagram.svg')
          },
          {
            network: 'Twitter',
            link: 'https://twitter.com/jdihklaten',
            icon: require('@/assets/sosmed/twitter.svg')
          }
        ],
        people: [
          { short: 'Hari ini', number: '-' },
          { short: 'Kemarin', number: '-' },
          { short: 'Bulan ini', number: '-' },
          { short: 'Tahun ini', number: '-' },
          { short: 'Total', number: '-' }
        ]
      }
    },
    computed: {
      year () {
        return new Date().getFullYear()
      },
      set_color () {
        return this.$store.state.header.config.color
      },
      accentColor () {
        const color = this.set_color || '#a20000'
        if (typeof color === 'string' && /^#[0-9A-Fa-f]{8}$/.test(color)) {
          return color.slice(0, 7)
        }
        return color
      },
      accentRgb () {
        const hex = (this.accentColor || '#a20000').replace('#', '')
        const full = hex.length === 3
          ? hex.split('').map(c => c + c).join('')
          : hex
        const n = parseInt(full, 16)
        return {
          r: (n >> 16) & 255,
          g: (n >> 8) & 255,
          b: n & 255
        }
      },
      accentDeep () {
        const { r, g, b } = this.accentRgb
        return `rgb(${Math.max(0, r - 28)}, ${Math.max(0, g - 18)}, ${Math.max(0, b - 18)})`
      },
      accentSoft () {
        const { r, g, b } = this.accentRgb
        return `rgba(${r}, ${g}, ${b}, 0.18)`
      }
    },
    watch: {
      '$route': function () {
        if (this.$route.path === '/beranda' || this.$route.path === '/') {
          this.save()
        }
      }
    },
    mounted () {
      if (this.$route.path === '/beranda' || this.$route.path === '/') {
        this.save()
      }
      this.fetch()
    },
    methods: {
      formatNumber (value) {
        if (value === '-' || value === null || value === undefined || value === '') {
          return '—'
        }
        const num = Number(value)
        if (Number.isNaN(num)) return value
        return num.toLocaleString('id-ID')
      },
      async save () {
        const url = 'sites/visitor/add'
        await this.$axios.$post(`${process.env.API}${url}`)
          .then((response) => {
            if (response.status === 200) {
              this.fetch()
            }
          })
      },
      async fetch () {
        await this.$axios.$get(`${process.env.API}sites/visitor/data`)
          .then((response) => {
            if (response.status === 200) {
              this.people[0].number = response.results.total_hari_ini
              this.people[1].number = response.results.total_kemarin
              this.people[2].number = response.results.total_bulan_ini
              this.people[3].number = response.results.total_tahun_ini
              this.people[4].number = response.results.total_semua
            }
          })
      }
    }
  }
</script>

<style scoped>
  .jdih-footer {
    width: 100%;
    color: #fff;
    background:
      radial-gradient(120% 90% at 0% 0%, rgba(255, 255, 255, 0.06), transparent 42%),
      radial-gradient(80% 70% at 100% 100%, rgba(255, 255, 255, 0.03), transparent 50%),
      linear-gradient(180deg, #111111 0%, #050505 100%);
  }

  .jdih-footer__inner {
    max-width: 1200px;
    margin: 0 auto;
    padding: 28px 12px 0;
  }

  .jdih-footer__main {
    display: grid;
    grid-template-columns: minmax(220px, 1.35fr) minmax(200px, 1fr) minmax(260px, 1.25fr) auto;
    gap: 28px 32px;
    align-items: start;
    padding-bottom: 22px;
  }

  .jdih-footer__brand {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    min-width: 0;
  }

  .jdih-footer__logos {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    padding-top: 2px;
  }

  .jdih-footer__logo {
    display: block;
    object-fit: contain;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.18));
  }

  .jdih-footer__logo--setwan {
    height: 32px;
    width: auto;
  }

  .jdih-footer__title {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: -0.01em;
    line-height: 1.25;
    color: #fff;
  }

  .jdih-footer__sub {
    font-size: 12px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.78);
    margin-top: 1px;
  }

  .jdih-footer__desc {
    margin: 10px 0 0;
    font-size: 12px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.72);
    max-width: 28ch;
  }

  .jdih-footer__label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.62);
    margin-bottom: 12px;
  }

  .jdih-footer__line {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 13px;
    line-height: 1.4;
    color: rgba(255, 255, 255, 0.92) !important;
    text-decoration: none !important;
    margin-bottom: 8px;
    min-height: 42px;
    padding: 0 14px;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.14);
    border-radius: 14px;
    transition: background-color 0.18s ease, border-color 0.18s ease, transform 0.18s ease;
  }

  .jdih-footer__line:last-of-type {
    margin-bottom: 0;
  }

  .jdih-footer__line:hover {
    transform: translateY(-1px);
    background: rgba(255, 255, 255, 0.12);
    border-color: rgba(255, 255, 255, 0.24);
    color: #fff !important;
  }

  .jdih-footer__line .v-icon {
    flex-shrink: 0;
  }

  .jdih-footer__stats {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
  }

  .jdih-footer__stat {
    min-width: 0;
    padding: 12px 14px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.14) 0%, rgba(255, 255, 255, 0.09) 100%);
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 16px;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
  }

  .jdih-footer__stat.is-total {
    grid-column: 1 / -1;
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 8px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.14) 100%);
    border-color: rgba(255, 255, 255, 0.24);
  }

  .jdih-footer__stat.is-total .jdih-footer__stat-num {
    font-size: 18px;
    color: #fff;
  }

  .jdih-footer__stat-num {
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.03em;
    font-variant-numeric: tabular-nums;
    color: #fff;
    line-height: 1.2;
  }

  .jdih-footer__stat-label {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.66);
    margin-top: 4px;
    white-space: nowrap;
  }

  .jdih-footer__stat.is-total .jdih-footer__stat-label {
    margin-top: 0;
    order: -1;
  }

  .jdih-footer__social {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .jdih-footer__social-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border: 1px solid rgba(255, 255, 255, 0.24);
    background: rgba(255, 255, 255, 0.1);
    border-radius: 999px;
    transition: background-color 0.18s ease, border-color 0.18s ease, transform 0.18s ease;
  }

  .jdih-footer__social-btn:hover {
    transform: translateY(-1px);
    border-color: rgba(255, 255, 255, 0.44);
    background: rgba(255, 255, 255, 0.18);
  }

  .jdih-footer__cta {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin-top: 16px;
    min-height: 42px;
    padding: 0 16px;
    font-size: 13px;
    font-weight: 600;
    color: #fff !important;
    text-decoration: none !important;
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 999px;
    transition: background-color 0.18s ease, border-color 0.18s ease, transform 0.18s ease;
  }

  .jdih-footer__cta:hover {
    transform: translateY(-1px);
    text-decoration: none !important;
    background: rgba(255, 255, 255, 0.18);
    border-color: rgba(255, 255, 255, 0.3);
  }

  .jdih-footer__bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 0 14px;
    border-top: 1px solid rgba(255, 255, 255, 0.18);
    font-size: 12px;
    color: rgba(255, 255, 255, 0.7);
  }

  @media (min-width: 1260px) {
    .jdih-footer__inner {
      max-width: 1280px;
      padding-left: 16px;
      padding-right: 16px;
    }
  }

  @media (max-width: 1100px) {
    .jdih-footer__main {
      grid-template-columns: 1.2fr 1fr;
      gap: 24px 28px;
    }

    .jdih-footer__col--stats {
      grid-column: 1 / -1;
    }

    .jdih-footer__stats {
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }

    .jdih-footer__stat.is-total {
      grid-column: auto;
      flex-direction: column;
      align-items: flex-start;
    }

    .jdih-footer__stat.is-total .jdih-footer__stat-label {
      order: 0;
      margin-top: 2px;
    }

    .jdih-footer__stat.is-total .jdih-footer__stat-num {
      font-size: 15px;
    }
  }
</style>

<style>
  .v-application a.jdih-footer__line,
  .v-application a.jdih-footer__cta,
  .v-application a.jdih-footer__social-btn {
    text-decoration: none !important;
  }

  .v-application a.jdih-footer__line {
    color: rgba(255, 255, 255, 0.92) !important;
  }

  .v-application a.jdih-footer__line:hover,
  .v-application a.jdih-footer__cta {
    color: #fff !important;
  }
</style>
